import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie';
import {routers} from './router';
import $http from '@/resource';
import utils from '@/utils';
import routeAuth from "@/staticData/routeAuthEnum";
import $api from '@/service/index';
import baseAuthEnum from "@/staticData/baseAuthEnum";
import store from '@/store/index'

// 路由配置
const RouterConfig = {
    mode: 'history',
    routes: routers
};
Vue.use(Router);

export const router = new Router(RouterConfig);

//手动忽略vue-router3.0版本以上由于使用promise导致同名路由的跳转问题（降版本也可以解决）
const originPush = Router.prototype.push;
Router.prototype.push = function push(location){
    //重写原型中的push方法，并忽略异常
    return originPush.call(this,location).catch(err=>err);
};

router.beforeEach((to,from,next)=>{
    //动态设置meta-title
    if(to.meta && to.meta.title){
        document.title = `${to.meta.title}-北屯经济技术开发区`;
    }else{
        document.title = `北屯经济技术开发区`;
    }
    if(needToLogin(to)){
        if(checkLogin()){
            let uid = Cookies.get('uid');
            refreshUserAuth(uid);
            //验权限
            let routerName = to.name;
            if(routeAuth[routerName] && routeAuth[routerName].auth){
                let authName = routeAuth[routerName].auth;
                let authType = routeAuth[routerName].type;
                let authRes = utils.judgeAuth(authName,authType);
                if(authRes !== true){
                    return next({ path: '/noauth'});
                }
            }
            
            // 公共信息
            getCommonInfo(uid);
            //待处理数
            store.dispatch('setCountWaitToHeadle', {fromName:from.name, toName:to.name});

            next();
        }else{
            next({
                replace: true,
                name: 'login-page'
            });
        }
    }else{
        next();
    }
    
});

/**
 * 更新localstorage中的用户权限
 *
 * @returns {Promise<any>}
 */
const refreshUserAuth = async (uid)=>{
    let myAuth = await $api.getUserPermissions();
    let stepData = await $api.companyStep();
    store.dispatch('setCompanyStep', stepData);
    if(stepData.step == '6'){
        myAuth.basic.push(baseAuthEnum.HASCOMPANY);
    }else{
        myAuth.basic.push(baseAuthEnum.HASNOTCOMPANY);
    }
    localStorage.setItem(`_tanikawa_user_${uid}_auth`, JSON.stringify(myAuth));
}

/**
 * 判断是否登入
 *
 * @return {bool undefined}
 */
const checkLogin = () => {
    return Cookies.get('token') && Cookies.get('uid') && Cookies.get('theOne');
}

/**
 * 判断是否需要登入
 *
 * @return {bool}
 */
const needToLogin = (to) => {
    const routerName = [
        'error-404', 
        'error-403',
        'error-500',
        'login-page',
        'wechat-jump',
        'no-auth',
        'app-download',
        'privacy'
    ];
    if(routerName.indexOf(to.name) === -1){
        return true;
    }else{
        return false;
    }
}

/**
 * 获取公共信息
 *
 * @return {bool}
 */
const getCommonInfo = (uid) => {
    $api.getCommomInfo().then( (data)=>{
        store.dispatch('setCommonData', data);
        localStorage.setItem(`_tanikawa_user_${uid}_commoninfo`, JSON.stringify(data));
    });
}


// WEBPACK FOOTER //
// ./src/router/index.js